import React, { useState, useEffect } from 'react';
import { AppBar, makeStyles, Menu, MenuItem, Button, } from '@material-ui/core';
import { authenticationService } from '../../Services/authentication.service';
import { Person } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { toast } from 'react-toastify';
import WorkstationNotificationsDrawer from '../Workstation/WorkstationNotificationsDrawer';
import { useHistory, useLocation } from 'react-router-dom';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { connect } from 'react-redux';
import { dataService } from '../../Services/data.service';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../Helpers/dateHelper';

export const HeaderBar = (props) => {

  let history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);

  const classes = useStyles();
  const { t } = useTranslation();
  const appSettings = props.appSettings

  useEffect(() => {
    dataService.getLatestNotifications().then(logs => {

      logs = logs.sort((a, b) => new Date(b.insertedOn) - new Date(a.insertedOn))
      props.actions.setNotifications(logs);
    }
    ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

  }, [props.notification.counter])

  useEffect(() => {
    const interval = setInterval(() => {
      authenticationService.userInfo(props.user.userToken).then(info => {
        if (info.sub !== props.user.userInfo.sub) {
          props.actions.setUserInfo(info)
          if (info == null) {
            logout();
          }
        }
      },
        error => {
          logout();
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });
    }, 3600000);

    const newHubConnection = new HubConnectionBuilder()
      .withUrl(appSettings.SMARTFACTORY_SHOPFLOOR_ORDER_HUB_URL)
      .withAutomaticReconnect()
      .build();

    newHubConnection.on('QuantityProducedUpdate', orderData => {
      console.log("From shopfloor hub quantity update: ")
      console.log(orderData)
      props.actions.refreshOrders(true)
    });

    newHubConnection.on('StatusUpdate', data => {
      console.log("From shopfloor hub state update: ")
      console.log(data)
      props.actions.setFinishedOrderIds(data.finishedOrderIds)
    });

    newHubConnection.on('NotificationReceived', data => {
      console.log("From shopfloor hub notifications: ")
      console.log(data)
      props.actions.incrementCounter()
    });

    newHubConnection.start().then(_ => {
      console.log('Shopfloor hub connected!');
    })
      .catch(e => console.log('Shopfloor hub connection failed: ', e));

    return () => clearInterval(interval);
    // eslint-disable-next-line

  }, []);

  const logout = () => {
    props.actions.setUserToken("");
    props.actions.setUserInfo("");
    history.push('/login');
  }

  const navigateSettings = () => {
    history.push('/settings');
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openNotificationsDrawer = () => {
    setNotificationDrawerOpen(true)
  }

  const closeNotificationsDrawer = () => {
    setNotificationDrawerOpen(false)
    props.actions.setCounter(0)
  }

  return <React.Fragment>
    <AppBar className={classes.appBar} position="fixed">
      <div className={classes.titleContainer}>
        <div className={classes.smartProduction}>
          <div className={classes.smart}>
            SMART
          </div>
          <div className={classes.production}>
            {props.nav.smart}
          </div>
        </div>
        <div className={classes.date}>
          {fromNewDateFormatToDDMMYYYYHHmmssSlash(new Date())}
        </div>
      </div>
      <button className={classes.notifications} onClick={() => openNotificationsDrawer()}>
        <img className={classes.notificationsIcon} alt="notifications" src={process.env.PUBLIC_URL + '/img/notifications.svg'}></img>
        {props.notification.counter > 0 ? <div className={classes.unread}>{props.notification.counter > 99 ? "+99" : props.notification.counter}</div> : <React.Fragment></React.Fragment>}
      </button>
      <div className={classes.userInfoContainer}>
        <Button aria-controls="simple-menu" aria-haspopup="true" className={classes.languageButton} onClick={handleClick}>
          <Person className={classes.person} /> <div className={classes.userInfo}>{props.user.userInfo ? props.user.userInfo.sub : ""}</div><div className={classes.expandArrow}>
            <ExpandMoreIcon className={classes.arrowIcon}></ExpandMoreIcon>
          </div>
        </Button>
        <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={navigateSettings}>{'Profile'}</MenuItem>
          <MenuItem onClick={navigateSettings}>{'UserManagement'}</MenuItem>
          <MenuItem onClick={logout}>{'Logout'}</MenuItem>
        </Menu>
      </div>
    </AppBar>
    <WorkstationNotificationsDrawer notifications={props.notification.notifications} openDrawer={openNotificationsDrawer} closeDrawer={closeNotificationsDrawer} drawerOpen={notificationDrawerOpen} {...props} actions={props.actions}></WorkstationNotificationsDrawer>
  </React.Fragment>
}

const useStyles = makeStyles({

  titleContainer: {
    float: 'left',
    width: "250px",
    display: 'inline-block',
    height: "45px",
    marginLeft: "70px"
  },
  person: {
    color: "#020100",
    marginTop: "3px",
    marginRight: "5px"
  },
  userInfo: {
    fontSize: "12px",
    fontFamily: "Lato, sans-serif",
    color: "#000000",
    marginTop: "3px",
  },
  userInfoContainer: {
    float: 'right',
    display: 'inline-block',
    width: "auto",
    height: "45px"
  },
  menuButton: {
    marginRight: '10px'
  },
  appBar: {
    backgroundColor: '#EFEFEF',
    boxShadow: "none",
    borderBottom: "1px solid #DEDEDE",
    height: "45px",
    display: 'inline-block',
    textAlign: "center"
  },
  smart: {
    display: 'block',
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: "#4654FF",
    height: "12px",
    marginTop: "5px",
    textAlign: "left"
  },
  production: {
    display: 'block',
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: "#000000",
    height: "12px"
  },
  arrowIcon: {
    fill: FlagstoneTheme.palette.primary.main,
    width: "20px",
    height: "20px"
  },
  expandArrow: {
    marginTop: "2px",
    marginLeft: "5px"
  },
  date: {
    fontSize: "11px",
    fontFamily: "Lato, sans-serif",
    color: "#8D8D8D",
    float: "left",
    marginTop: "15px",
    marginLeft: "10px"
  },
  smartProduction: {
    float: "left"
  },
  lines: {
    display: "inline",
    marginRight: "100px",
    position: "relative",
    top: "7px"
  },
  lineText: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    marginRight: "10px"
  },
  line: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    outline: "none",
    cursor: "pointer",
    border: "none"
  },
  selectedLine: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    color: "#4654FB",
    backgroundColor: "#E6E8FE",
    display: "inline",
    outline: "none",
    border: "1px solid white",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
  },
  unread: {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    backgroundColor: "#D84949",
    position: "relative",
    left: "11px",
    bottom: "7px",
    color: "white",
    fontSize: "10px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    paddingTop: "2px"
  },
  notifications: {
    float: "right",
    border: "none",
    outline: "none",
    cursor: "pointer",
    backgroundColor: "rgb(1,1,1,0)"
  },
  notificationsIcon: {
    height: "17px",
    width: "17px",
    marginTop: "11px",
    marginRight: "20px"
  }
});

function mapStateToProps(state) {
  return {
    order: state.order,
    notification: state.notification
  }
}

export default connect(mapStateToProps)(HeaderBar)